<template>
  <div :key="updatedAt">
    <h1>User Roles</h1>
    <UserRoleEdit
      :item="{ settings: { menu: [], general: [], notifications: [] } }"
      @onAddItem="onEditItem"
      class="mb-3"
    />
    <top-table
      :order-by="{ column: 'createdAt', ascending: 0 }"
      :headings="{ createdAt: 'Created On' }"
      :sortable="['name', 'createdAt']"
      ref="table"
      :columns="columns"
      url="/user-roles"
      :requestFunction="requestFunction"
      :overlap="true"
    >
      <template v-slot:actions="props">
        <span class="d-flex" :key="props.row._id">
          <UserRoleEdit :item="props.row" @onEditItem="onEditItem" />
          <UserRoleEdit @onDeleteItem="onEditItem" :action="'delete'" :item="props.row" />
        </span>
      </template>
      <template v-slot:tools="props">
        {{
          Object.keys(props.row.settings || {})
            .map((key) => (key === '_id' ? [] : props.row.settings[key]))
            .reduce((a, b) => [...a, ...b], [])
            .join(',')
        }}
      </template>
      <template v-slot:createdAt="props">
        {{ props.row.createdAt | dateWithTime }}
      </template>
    </top-table>
  </div>
</template>
<script>
export default {
  components: {
    UserRoleEdit: () => import('./EditForm')
  },
  data() {
    return {
      columns: ['name', 'description', 'tools', 'createdAt', 'actions'],
      updatedAt: Date.now()
    };
  },
  methods: {
    requestFunction(q) {
      q.withDistributors = 1;
    },
    onEditItem() {
      this.updatedAt = Date.now();
    }
  }
};
</script>
